const $ = require('jquery');

const Filter = {
	$positions: [],
	$positions_container: [],
	$no_results: [],
	$filter_feedback: [],
	old_on_pop_state: function() { },
	criteria: new Map(),
	init() {
		if ( $('.js-positions-filter').length > 0 ) {
			this.setup();
		}
	},
	setup() {
		this.setupPositionsFilters();
		this.$positions = $('.js-positions-list .vcex-post-type-entry');
		this.$positions_container = this.$positions.parents('.vcex-post-type-grid-wrap:first');
		this.setupNoResults();
		this.setupFilterFeedback();
		this.setupPopState();
		this.handleQueryState();
	},
	isTouchDevice() {
		return ( 'ontouchstart' in window ) ||
			( navigator.maxTouchPoints > 0 ) ||
			( navigator.msMaxTouchPoints > 0 )
		;
	},
	setupNoResults() {
		this.$no_results = this.$positions_container.find('.js-positions-filter-no-results');
		if ( this.$no_results.length === 0 ) {
			this.$no_results = $('<div class="c-positions-filter__no-results js-positions-filter-no-results"></div>');
			this.$positions_container.prepend(this.$no_results);
		}
	},
	setupFilterFeedback() {
		this.$filter_feedback = this.$positions_container.find('.js-positions-filter-feedback');
		if ( this.$filter_feedback.length === 0 ) {
			this.$filter_feedback = $('<div class="c-positions-filter__feedback js-positions-filter-feedback"></div>');
			this.$positions_container.prepend(this.$filter_feedback);
		}
	},
	setupPositionsFilters() {
		$('.js-positions-filter').each( (i, el) => {
			const $$ = $(el);
			if ( this.isTouchDevice() ) {
				$$.find('label').on( 'click.epicPosFilter', () => this.touchToggle($$) );
			} else {
				$$.on( 'mouseenter', () => this.open($$) );
				$$.on( 'mouseleave', () => this.close($$) );
			}
			const $options = $$.find('.js-positions-option-list');
			if ( !this.isTouchDevice() ) {
				$options.on( 'mouseenter', () => this.open($$) );
				$options.on( 'mouseleave', () => this.close($$) );
			}
			$$.on('click', '.js-positions-option', this.filterClickCallback.bind(this));
		});
	},
	handleQueryState() {
		const types = [ 'location', 'department' ];
		const params = new URLSearchParams(window.location.search);
		types.forEach( type => {
			if ( params.has(type) ) {
				this.criteria.set(type, params.get(type));
			}
		} );
		this.filterPositions(true);
	},
	setupPopState() {
		if ( typeof window.onpopstate === 'function' ) {
			this.old_on_pop_state = window.onpopstate;
		}
		window.onpopstate = this.handlePopState.bind(this);
	},
	handlePopState(event) {
		if ( event.state.criteria ) {
			this.criteria = event.state.criteria;
			this.filterPositions(true);
		}
		this.old_on_pop_state(event);
	},
	touchToggle($$) {
		if ( $$.hasClass('is-open') ) {
			$$.removeClass('is-open');
		} else {
			$$.addClass('is-open');
		}
	},
	open($$) {
		window.clearTimeout($$.data('timeout_id'));
		$$.addClass('is-open');
	},
	close($$) {
		$$.data('timeout_id', window.setTimeout( () => $$.removeClass('is-open'), 200 ));
	},
	filterClickCallback(event) {
		const $$ = $(event.currentTarget);
		const slug = $$.data('slug');
		// const name = $$.data('name');
		const type = $$.hasClass('js-location') ? 'location' : 'department';

		if ( this.isTouchDevice() ) {
			$$.parents('.js-positions-filter').removeClass('is-open');
		}

		if ( slug === '*' ) {
			this.criteria.delete(type);
		} else {
			this.criteria.set(type, slug);
		}

		this.filterPositions();
	},

	getName(type, slug) {
		return $('.js-positions-filter').find(`.js-${type}[data-slug="${slug}"]`).data('name');
	},
	capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	},
	labelify(type) {
		return this.capitalizeFirstLetter(type);
	},
	updateFilterFeedback() {
		if ( this.criteria.size === 0 ) {
			this.$filter_feedback.html('');
		} else {
			let terms = [];
			for ( const [type, slug] of this.criteria ) {
				const name = this.getName(type, slug);
				const label = this.labelify(type);
				terms.push(`<span><b>${label}:</b> ${name}</span>`);
			}
			this.$filter_feedback.html( terms.join(' <i>and</i> ') );
		}
	},
	filterPositions(skipUrlUpdate = false) {
		this.updateFilterFeedback();
		if ( this.criteria.size === 0 ) {
			this.$positions.show();
		} else {
			this.$positions.hide().filter(this.shouldShow.bind(this)).show();
		}

		if ( !skipUrlUpdate ) {
			this.updateUrl();
		}

		if ( this.$positions.filter(':visible').length === 0 ) {
			this.$no_results.text('No results');
		} else {
			this.$no_results.text('');
		}
	},
	updateUrl() {
		const url = new URL(window.location.origin + window.location.pathname);
		if ( this.criteria.size > 0 ) {
			for ( const [type, slug] of this.criteria ) {
				url.searchParams.set(type, slug);
			}
		}
		window.history.pushState({ criteria: this.criteria }, null, url);
	},
	shouldShow(i, el) {
		const $$ = $(el);
		for (const [type, slug] of this.criteria) {
			if ( $$.data(type) !== slug ) {
				return false;
			}
		}
		return true;
	}
};
$(Filter.init.bind(Filter));
